import { useEffect, useState } from "react";

import { watchAnnouncements } from "@/data/announcements.repo";
import type { Announcement } from "@/data/types";
import { readCache, writeCache } from "@/lib/cache";

const KEY = "jmd:announcements";

export function useAnnouncements(): Announcement[] {
  const [items, setItems] = useState<Announcement[]>(() =>
    readCache<Announcement[]>(KEY, []),
  );
  useEffect(() => {
    return watchAnnouncements((v) => {
      setItems(v);
      writeCache(KEY, v);
    });
  }, []);
  return items;
}
